import React from 'react';
import Moment from 'moment';

// ─── utilidades para reordenar (click en título de columna) las tablas
// "a mano" que reemplazaron a react-table en varias vistas. react-table
// traía el sort gratis; estas tablas nuevas no, así que lo reponemos acá
// una sola vez y se reusa donde haga falta. ───────────────────────────────

const DATE_FORMATS = ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss', 'DD/MM/YYYY', 'DD-MM-YYYY'];

function isEmptyValue(v) {
  return v === null || v === undefined || v === '' || v === '—';
}

function tryParseDate(v) {
  if (v instanceof Date) return v;
  if (typeof v !== 'string') return null;
  const m = Moment(v, DATE_FORMATS, true);
  return m.isValid() ? m.toDate() : null;
}

function compareValues(va, vb) {
  if (typeof va === 'number' && typeof vb === 'number') return va - vb;

  const na = typeof va === 'number' ? va : (typeof va === 'string' && va.trim() !== '' && !isNaN(va) ? parseFloat(va) : NaN);
  const nb = typeof vb === 'number' ? vb : (typeof vb === 'string' && vb.trim() !== '' && !isNaN(vb) ? parseFloat(vb) : NaN);
  if (!isNaN(na) && !isNaN(nb)) return na - nb;

  const da = tryParseDate(va);
  const db = tryParseDate(vb);
  if (da && db) return da.getTime() - db.getTime();

  return String(va).localeCompare(String(vb), 'es', { sensitivity: 'base' });
}

// sort = { key, dir } ; key null => sin ordenar (orden original)
export function sortRows(rows, sort) {
  if (!sort || !sort.key) return rows;
  const dirMult = sort.dir === 'desc' ? -1 : 1;
  return [...rows].sort((a, b) => {
    const va = a[sort.key];
    const vb = b[sort.key];
    const aEmpty = isEmptyValue(va);
    const bEmpty = isEmptyValue(vb);
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1; // los vacíos siempre al final, en cualquier dirección
    if (bEmpty) return -1;
    return dirMult * compareValues(va, vb);
  });
}

export function nextSort(sort, key) {
  if (!sort || sort.key !== key) return { key, dir: 'asc' };
  return { key, dir: sort.dir === 'asc' ? 'desc' : 'asc' };
}

// header = string (no ordenable) u { label, key } (ordenable por item[key])
export function SortableTh({ header, sort, onSort, style }) {
  const isObj = typeof header === 'object' && header !== null;
  const label = isObj ? header.label : header;
  const key = isObj ? header.key : null;
  const sortable = !!key;
  const active = sortable && sort && sort.key === key;

  return (
    <th
      onClick={sortable ? () => onSort(key) : undefined}
      style={{
        padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap',
        cursor: sortable ? 'pointer' : 'default', userSelect: 'none',
        ...style,
      }}
      title={sortable ? 'Ordenar' : undefined}
    >
      {label}
      {sortable && (
        <i
          className={'fa ' + (active ? (sort.dir === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort')}
          style={{ marginLeft: 6, fontSize: 11, color: active ? '#27ae60' : '#ccc' }}
        />
      )}
    </th>
  );
}
